<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h4>Date Options for {{ formatted_date }}</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
          <DateOptionsForm :date="date"></DateOptionsForm>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import DateOptionsForm from '../../../components/Scheduler/Calendar/DateOptionsForm.vue'

export default {
  props: ['date'],
  components: { DateOptionsForm },
  data: function () {
    return {
      formatted_date: moment(this.date).format('MMMM Do YYYY')
    }
  }
}
</script>
